import { useGetOrderDetailsQuery } from "@/store/api/orderApi";
import PageLoader from "../ui/PageLoader";

type Props = {
  id: number;
  onCancel: () => void;
};

const OrderDetails = (props: Props) => {
  const { id, onCancel } = props;

  const { data: order, isLoading: loading } = useGetOrderDetailsQuery({
    id,
  });

  return (
    <PageLoader isFetching={loading}>
      <div className="bg-white rounded-lg shadow-md p-6 max-w-md mx-auto">
        <h2 className="text-xl font-bold text-center">#{order?.order_name}</h2>

        <div className="mb-8 border border-gray-300 rounded-md p-4 mt-4 text-sm">
          <h3 className="text-lg font-medium mb-2 text-center">
            {(order?.order_type || "").toUpperCase()}
          </h3>

          <div className="flex justify-between mt-4">
            <span>{order?.payment_type}</span>

            <span>
              {order?.created_at.substring(0, 10)}{" "}
              {order?.created_at.substring(11, 19)}
            </span>
          </div>

          <ul className="my-4 border-t border-b border-dashed border-gray-500 py-4">
            {order &&
            Array.isArray(order.order_items) &&
            order.order_items.length > 0 ? (
              order.order_items.map((item) => (
                <li
                  key={item.product_id}
                  className="grid grid-cols-2 items-center"
                >
                  <div className="grid grid-cols-3 justify-start">
                    <span className="text-left">{item.quantity}</span>
                    <span className="col-span-2">{item.product_name}</span>
                  </div>
                  <span className="text-right">${item.price_set}</span>
                </li>
              ))
            ) : (
              <li className="text-center text-gray-500">No items found</li>
            )}
          </ul>

          <div className="mb-2">
            <h4 className="font-medium">Comments</h4>
            <p className="ml-3 mt-3 text-gray-600">{order?.order_comments}</p>
          </div>

          <div className="border-t border-b border-gray-500 border-dashed my-4 py-4">
            <div className="flex justify-between">
              <span className="font-medium">Subtotal</span>
              <span className="text-gray-700">${order?.subtotal_price}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium">Tax:</span>
              <span>${order?.tax}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium">Tip:</span>
              <span>$ {order?.tip}</span>
            </div>

            <div className="flex justify-between">
              <span className="font-medium">Service Fee:</span>
              <span>$ {order?.surcharge_fee ?? "0.00"}</span>
            </div>

            <div className="flex justify-between mt-2">
              <span className="font-medium">Total:</span>
              <span>$ {order?.total_price}</span>
            </div>
          </div>
          <div className="mt-4 text-center">
            <span className="text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
              {(order?.payment_status || "").toUpperCase()}
            </span>
          </div>
        </div>

        <button
          className="mt-4 w-full bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          onClick={onCancel}
        >
          Close
        </button>
      </div>
    </PageLoader>
  );
};

export default OrderDetails;
